import { StoreAction } from "../../interfaces/redux.interface";

export const SET_REP_ENTER_CUSTOMER_MODE = 'SET_REP_ENTER_CUSTOMER_MODE'

export const setRepEnterCustomerMode = (customerData: any): StoreAction<undefined> => ({
	type: SET_REP_ENTER_CUSTOMER_MODE,
	payload: customerData,
});

